import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '@drl/core/auth/models/user.model';
import { DatePipe, Location } from '@angular/common';
import { RouteComponentBase } from '@drl/core/route-component-base';
import { AppoinmentService } from '../appoinment.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { NurshingNoteComponent } from '../nurshing-note/nurshing-note.component';
import { GetAppoinmentModel } from '@drl/shared/models';
import {
  CONSTANTSSTATUS,
  CONSTSFGENTYPE,
} from '../dialog-edit-appointment/flags.const';
import { EventFacadeService } from '../event-facade.service';
import { environment } from '@drl/env/environment';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { TranslateService } from '@ngx-translate/core/lib/translate.service';
import { UserStatus, userStatusTypesMap } from '@drl/core/enums/user-status.enum';

@Component({
  selector: 'app-dialog-feedback',
  templateUrl: './dialog-feedback.component.html',
  styleUrls: ['./dialog-feedback.component.scss'],
})
export class DialogFeedbackComponent extends RouteComponentBase {
  readonly CONSTANTS = CONSTANTSSTATUS;
  readonly CONSTGENTYPE = CONSTSFGENTYPE;
  readonly brand = environment.brand;
  user: GetAppoinmentModel;
  returncareGiverId;
  returnMeetingId;
  returnAppointmentId;
  feedbackForm: FormGroup;
  feedbackNoDiv = false;
  feedbackYesDiv = true;
  firstParam;
  secondParam;
  feedbackYesBtnValue;
  feedbackNoBtnValue;
  reasonValue;
  userSavedMsg: string;
  successLbl: string;
  errorLbl: string;
  users: User[] = [];
  IsEdit = false;
  ptsDetailsById;
  loading = false;
  age;
  careGiverDetails;
  careGiverGroupDetails;
  dateTimeDetails;
  feedBackRequestResult;
  textRating;
  attendeeDetails;
  public ptsImageUrl;
  disableSubmitFeedback = false;
  ptsImageUrlEdit;
  appointmentId;
  guestAge;
  guestGender;
  alternativeContactDetails;
  externalId;
  showcontent = false;
  isLoading = false;
  statuses = [];
  userRemovalConfirmationMsg: string;
  userDeleteSuccessMsg: string;
  maleTextLbl: string;
  femaleTextLbl: string;
  otherLbl: string;
  wentWrongLbl: string;
  constructor(
    public dialogRef: NbDialogRef<DialogFeedbackComponent>,
    route: ActivatedRoute,
    private readonly formBuilder: FormBuilder,
    location: Location,
    private readonly dialogService: NbDialogService,
    private readonly toastrService: ToastrService,
    public readonly patientService: AppoinmentService,
    protected readonly router: Router,
    private readonly eventFacade: EventFacadeService,
    private readonly datePipe: DatePipe,
    protected readonly translateSvc: IpsTranslateService,
  ) {
    super(route, location);
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;

  ngOnInit() {
    this.getTranslations();
    if (this.router.url.includes('meeting')) {
      let url = this.router.url.split('care-central')[1];
      url = url.split('?meeting=')[1];
      const meeting = url;
      this.loading = true;
      const data = {
        filterDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        tenantName: environment.tenantName,
      };
      this.eventFacade.getAllAppointmentsNew(data).subscribe(res => {
        if (res.responseCode !== this.CONSTANTS.successCode) {
          return;
        }
        const dataAppointment = res.responseResult.appointmentList;
        this.user = dataAppointment.filter(
          response => response.meetingId === meeting,
        );
        this.user = this.user[0];
        this.loading = false;
        this.isUser(true);
      });
    } else {
      this.isUser(true);
    }
    this.feedbackFrom();
    this.feedbackForm.controls['rate_yes'].setValidators([Validators.required]);
    this.feedbackForm.controls['rate_yes'].updateValueAndValidity();
    if (this.returnMeetingId) {
      this.getFeedbackRequestParam(this.returnMeetingId);
    }
  }

  guestAgeGender(guestID: number): void {
    const gID = {
      appointmentId: guestID,
    };
    this.patientService.getPatientsDetailsById(gID).subscribe(res => {
      this.guestAge = res.responseResult.age;
      this.guestGender = res.responseResult.gender;
    });
  }

  isUser(user) {
    if (user) {
      this.getPatientDetails();
      this.appointmentId = this.user.id;
      if (this.user.patientImageUrl != null && this.user.patientImageUrl) {
        this.ptsImageUrlEdit = this.user.patientImageUrl;
      } else if (this.user.patientImg != null && this.user.patientImg) {
        this.ptsImageUrlEdit = this.user.patientImg;
      } else {
        this.ptsImageUrlEdit = '../../../../assets/patient-avatar.png';
      }
      if (this.user.patientType === 'guest_patient') {
        this.guestAgeGender(this.user.id);
      }
      // this.getAlternativeEmailAndMob(this.appointmentId);// Commenting for MVP
    }
  }

  /* getAlternativeEmailAndMob(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getAlternativeEmailAndMob(body).subscribe(res => {
      this.alternativeContactDetails = res.responseResult;
    });
  } */ // Commenting for MVP

  getPatientDetails() {
    this.loading = true;
    this.patientService.getPatients().subscribe(res => {
      this.ptsDetailsById = res;
      this.ptsDetailsById = this.ptsDetailsById.find(
        x => x.id === this.user.patientId,
      );
      this.externalId = this.ptsDetailsById.externalId;
      this.age = this.ageFromDateOfBirthday(this.ptsDetailsById.dob);
      this.getCaregiverGroup(this.ptsDetailsById.careGroupId);
      this.loading = false;
    });
  }
  public ageFromDateOfBirthday(dateOfBirth): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  feedbackFrom() {
    this.feedbackForm = this.formBuilder.group({
      feedbackbtn: [''],
      feedback_no: [''],
      feedback_yes: [''],
      rate_yes: [''],
      reason: [''],
    });
  }
  get f() {
    return this.feedbackForm.controls;
  }
  showContent(e) {
    const activeReason = '3';
    if (e.target.value === activeReason) {
      this.showcontent = true;
    } else {
      this.showcontent = false;
    }
  }
  submitFeedback() {
    this.isLoading = true;
    if (this.feedbackForm.valid) {
      this.disableSubmitFeedback = true;
      if (
        this.feedbackForm.controls['feedbackbtn'].value === '1' ||
        !this.feedbackForm.controls['feedbackbtn'].value
      ) {
        const feedbackData = {
          appointmentHappened: 1,
          appointmentId: this.returnAppointmentId,
          feedback: this.feedbackForm.value.feedback_yes,
          happyUnhappyReason: '',
          rating: this.feedbackForm.value.rate_yes,
        };
        this.patientService.saveFeedback(feedbackData).subscribe(
          res => {
            this.nursingNoteAddPopUp(
              this.returncareGiverId,
              this.returnAppointmentId,
              this.user,
            );
            this.updateAppointment(this.returnAppointmentId, 'Completed');
          },
          error => {
            this.loading = false;
            this.toastrService.error(this.wentWrongLbl, this.errorLbl, {});
          },
        );
      } else {
        const feedbackData = {
          appointmentHappened: this.feedbackForm.controls['feedbackbtn'].value,
          appointmentId: this.returnAppointmentId,
          callNotHappendReason: this.feedbackForm.value.reason,
          feedback: this.feedbackForm.value.feedback_no,
          happyUnhappyReason: '',
        };
        this.patientService.saveFeedback(feedbackData).subscribe(
          res => {
            this.nursingNoteAddPopUp(
              this.returncareGiverId,
              this.returnAppointmentId,
              this.user,
            );
            this.updateAppointment(this.returnAppointmentId, 'Unsuccessful');
          },
          error => {
            this.loading = false;
            this.toastrService.error(this.wentWrongLbl, this.errorLbl, {});
          },
        );
      }
    }
  }
  feedbackYes(event) {
    this.feedbackNoDiv = false;
    this.feedbackYesDiv = true;
    this.showcontent = false;
    this.feedbackForm.get('reason').clearValidators();
    this.feedbackForm.controls.reason.reset();
    this.feedbackForm.controls['rate_yes'].setValidators([Validators.required]);
    this.feedbackForm.controls['rate_yes'].updateValueAndValidity();
    this.feedbackYesBtnValue = event.val;
  }
  feedbackNo(event) {
    this.feedbackYesDiv = false;
    this.feedbackNoDiv = true;
    this.feedbackForm.get('rate_yes').clearValidators();
    this.feedbackForm.controls.rate_yes.reset();
    this.feedbackForm.controls['reason'].setValidators([Validators.required]);
    this.feedbackForm.controls['reason'].updateValueAndValidity();
    this.feedbackNoBtnValue = event.val;
  }

  refresh() {
    this.users = [];
  }

  getCaregiver(body) {
    this.loading = true;
    this.patientService.getCaregiver(body).subscribe(res => {
      this.careGiverDetails = res;
      if (this.careGiverDetails.photoUrl != null) {
        this.ptsImageUrl = this.careGiverDetails.photoUrl;
      } else {
        this.ptsImageUrl = '../../../../assets/patient-avatar.png';
      }
      this.getCaregiverGroup(this.careGiverDetails.careGroupId);
      this.loading = false;
    });
  }
  getCaregiverGroup(body) {
    this.loading = true;
    this.patientService.getCaregiverGroup(body).subscribe(res => {
      this.careGiverGroupDetails = res;
      this.loading = false;
    });
  }
  getDateTimeDetailsById(val: string) {
    const body = {
      appointmentId: this.returnAppointmentId,
    };
    this.patientService.getDateTimeById(body).subscribe(res => {
      this.dateTimeDetails = res.responseResult;
    });
  }
  getFeedbackRequestParam(val: string) {
    const body = {
      webexMeetingId: val,
    };
    this.patientService.getFeedbackRequestParam(body).subscribe(res => {
      if (res.responseMessage === 'Success') {
        this.feedBackRequestResult = res.responseResult;
        this.returncareGiverId = res.responseResult.caregiverId;
        this.returnAppointmentId = res.responseResult.appointmentId;
      }
    });
  }
  updateAppointment(val: string, status) {
    const body = {
      appointmentId: val,
      status: status,
    };
    this.patientService.updateAppointmnent(body).subscribe();
  }

  nursingNoteAddPopUp(
    returncareGiverId,
    returnAppointmentId,
    user?: GetAppoinmentModel,
  ): void {
    this.dialogRef.close();
    const context = {
      careGiverId: returncareGiverId,
      AppointmentId: returnAppointmentId,
      user: Object.assign({}, user || new GetAppoinmentModel()),
      hasBackdrop: true,
      closeOnBackdropClick: false,
    };

    this._subscriptions.push(
      this.dialogService
        .open(NurshingNoteComponent, {
          context,
        })
        .onClose.subscribe(res => {
          if (res && res.error) {
            this.toastrService.error(res.message, this.errorLbl, {});
          } else {
            this.refresh();
            this.toastrService.success(this.userSavedMsg, this.successLbl);
          }
        }),
    );
  }
  getAttendeeList(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getAttendeeList(body).subscribe(res => {
      this.attendeeDetails = res.responseResult;
    });
  }
  getTranslations() {
    this.translate
      .get([
        'userSavedMsgFeedback',
        'userRemovalConfirmationMsg',
        'userDeleteSuccessMsg',
        'successLbl',
        'errorLbl',
        'phoneNotValidMsg',
        'maleTextLbl',
        'femaleTextLbl',
        'otherLbl',
        'wentWrongLbl',
      ])
      .subscribe(res => {
        this.statuses = [
          userStatusTypesMap(this.translate)[UserStatus.REGISTERED],
          userStatusTypesMap(this.translate)[UserStatus.ACTIVE],
          userStatusTypesMap(this.translate)[UserStatus.INACTIVE],
        ];
        this.userSavedMsg = res.userSavedMsgFeedback;
        this.userRemovalConfirmationMsg = res.userRemovalConfirmationMsg;
        this.userDeleteSuccessMsg = res.userDeleteSuccessMsg;
        this.successLbl = res.successLbl;
        this.errorLbl = res.errorLbl;
        this.maleTextLbl = res.maleTextLbl;
        this.femaleTextLbl = res.femaleTextLbl;
        this.otherLbl = res.otherLbl;
        this.wentWrongLbl = res.wentWrongLbl;
      });
  }
  public getGenderLbl(genderLbl: string) {
    if (
      genderLbl === this.CONSTGENTYPE.Male ||
      genderLbl === this.CONSTGENTYPE.GMale
    ) {
      return this.maleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Female ||
      genderLbl === this.CONSTGENTYPE.GFemale
    ) {
      return this.femaleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Other ||
      genderLbl === this.CONSTGENTYPE.GOther
    ) {
      return this.otherLbl;
    } else {
      return null;
    }
  }
}
